import { render, staticRenderFns } from "./RevenueAnalytic.vue?vue&type=template&id=48f574b6&scoped=true&"
import script from "./RevenueAnalytic.vue?vue&type=script&lang=js&"
export * from "./RevenueAnalytic.vue?vue&type=script&lang=js&"
import style0 from "./RevenueAnalytic.vue?vue&type=style&index=0&id=48f574b6&prod&lang=scss&scoped=true&"
import style1 from "./RevenueAnalytic.vue?vue&type=style&index=1&id=48f574b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f574b6",
  null
  
)

export default component.exports